import React from "react"
import { Skeleton } from "@material-ui/lab"
import { TableRow, TableCell } from "@material-ui/core"
import { SkeletonProps, ColumnSkeleton } from "@/protocols/skeleton"

const columnSkeletons: ColumnSkeleton[] = [
	{ width: 130, height: 16, borderRadius: 4 },
	{ width: 50, height: 16, borderRadius: 4 },
	{ width: 50, height: 16, borderRadius: 4 },
	{ width: 50, height: 16, borderRadius: 4 }
]

const ProductMessageMetricsSkeleton: React.FC<SkeletonProps> = ({ rows = 7 }) => {
	return (
		<>
			{Array.from({ length: rows }).map((_, idx) => (
				<TableRow key={idx}>
					{columnSkeletons.map((col, cIdx) => (
						<TableCell key={cIdx}>
							<Skeleton
								variant="rect"
								width={col.width}
								height={col.height}
								style={{ borderRadius: col.borderRadius }}
							/>
						</TableCell>
					))}
				</TableRow>
			))}
		</>
	)
}

export default ProductMessageMetricsSkeleton
